$.widget("bluaul.vcOptionBox",
{
    /// <summary>
    /// Author: AFU<br />
    /// Date: 3.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.11.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    self: null,
    index:0,
    resources: window.__OptionBoxResources,

    _getResources: function () {return this.resources[this.options.langID - 2];},

    options: {
        caption: "",
        langID: 2,
        captionWidth: null,
        items: [{button:'Default', content:'', funct: null, clickable:false, isList:false, width: 0}]
       
    },
    _destroy: function () {
        this.element.removeClass("vc-option-box").html("");
    },
    getOptions: function () {
        return this.options;
    },

    updateBtnHtml: function (index, text) {
        if (this.btn[index] == null) return;

        // input header
        if (this.options.items[index] && this.options.items[index].input != null) {
            this.btn[index].val(text);
            return;
        }

        // button header (old behavior)
        this.btn[index].find("span").html(text);
    },

    _create: function() {
        var i;

        this.element.removeClass("vc-option-box").addClass("vc-option-box vc-grid-2col");
        self = this;
        var me = this;
        //##################### WIDGET ######################

        if (this.options.caption.length === 0) {
            this.options.caption = this._getResources().defaultCaption;
        }

        me.divHeader = $("<div>").addClass("header");
        me.divCaption = $("<div>").addClass("caption");

        if (this.options.caption.length > 0) {
            me.divCaption.html(this.options.caption );
        } else {
            me.divCaption.html('<br/>');
        }    

        me.divMenu = $("<div>").addClass("menu");
        me.divContent = $("<div>").addClass("content");

        if (this.options.captionWidth != null) {
            me.divCaption.css("width", this.options.captionWidth + "%");
            me.divMenu.css("width", (100 - this.options.captionWidth) + "%");
        }

        me.btn = [];
        me.content = [];
        me.input = [];

        for (i = 0; i <= this.options.items.length - 1; i++) {

            var it = this.options.items[i];
            var headerEl = null;

            // ---------------------------------------------
            // NEW: allow input in header instead of button
            // it.input can be: string OR { value, placeholder, readonly, maxlength, onChange }
            // ---------------------------------------------
            if (it.input != null) {

                var cfg = (typeof it.input === "object") ? it.input : { value: it.input };

                headerEl = $("<input type='text' />").addClass("button-toggle optionbox-input ui-button ui-widget ui-state-default ui-corner-all").data("index", i).val(cfg.value != null ? cfg.value : "");

                if (cfg.placeholder != null) headerEl.attr("placeholder", cfg.placeholder);
                if (cfg.maxlength != null) headerEl.attr("maxlength", cfg.maxlength);
                if (cfg.readonly === true) headerEl.prop("readonly", true);

                // prevent header selection click when user focuses/clicks inside the input
                headerEl.on("click mousedown", function (e) { e.stopPropagation(); });

                // optional change callback
                headerEl.on("input change", function () {
                    var idx = $(this).data("index");
                    var itemCfg = me.options.items[idx];
                    if (itemCfg != null && itemCfg.input != null) {
                        var c = (typeof itemCfg.input === "object") ? itemCfg.input : null;
                        if (c && $.isFunction(c.onChange)) {
                            c.onChange($(this).val(), idx, me);
                        }
                    }
                });

                me.input[i] = headerEl;

                // keep API compatibility: me.btn[i] exists
                me.btn[i] = headerEl;

            } else {
                // existing behaviour: button
                headerEl = $("<div>")
                    .addClass("button-toggle")
                    .data("index", i)
                    .html(it.button)
                    .button();

                me.btn.push(headerEl);
            }

            // active style like before
            if (i === 0) {
                headerEl.addClass("button-toggle-active");
            }

            // width logic MUST stay identical
            if (it.width != null)
                headerEl.css("width", (it.width - 1) + "%");
            else
                headerEl.css("width", (parseInt(100 / this.options.items.length, 10) - 2) + "%");

            me.divMenu.append(headerEl);

            // content part stays unchanged
            me.content.push($("<div>").addClass("content-item").data("index", i).html(it.content));
            if (i > 0) { me.content[i].addClass("hide"); }
            me.divContent.append(me.content[i]);
        }
     
        me.divHeader.append(me.divCaption, me.divMenu);
        me.element.append(me.divHeader, me.divContent);


       if (this.options.items.length > 0) {
           for (i = 0; i <= this.options.items.length - 1; i++) {
               if (this.options.items[i].clickable && this.options.items[i].input == null) {
                   me.btn[i].on("click", function () { me._select($(this).data("index")) });
               } else {
                   me.btn[i].addClass("not-clickable");
               }
               if (this.options.items[i].isList) {
                   me.content[i].addClass("is-list");
               }
           }

          
           if ($.isFunction(this.options.items[0].funct)) this.options.items[0].funct();
       } 
        return this;
    },
    //##################### FUNCTIONS #######################################

    _select: function (index) {
        this.divMenu.find(".button-toggle").removeClass("button-toggle-active");
        this.btn[index].addClass("button-toggle-active");
        this.divContent.find(".content-item").addClass("hide");
        this.content[index].removeClass("hide");
        this.index = index;
        if ($.isFunction(this.options.items[index].funct)) this.options.items[index].funct();
        
    },

    selectItem: function (index) {
        this._select(index);
    },
    getIndex: function () {
       return this.index;
    },
    setIndex: function (index) {
        this._select(index);
        return this.index;
    },

    callback: function () { if ($.isFunction(this.options.callback)) this.options.callback(this.options) }

    , destroy: function () {
        callback = null;
        this._super();
    }

});


$.widget("bluaul.vcDateBox",
{
    /// <summary>
    /// Author: AFU<br />
    /// Date: 3.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.11.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    self: null,
    mycal:null,

    resources: window.__OptionBoxResources,

    _getResources: function () {
       
        return this.resources[this.options.langID - 2];
    },


    options: {
        langID: 2, mode: "Single", align: "center", interval: 1,
        defaultDate: null,
        defaultRange: { from: null, to: null }, callback: null
    },


    setSingleDate: function(sDate) {
        if (this.options.mode === "Single") {
            this.mycal.vcDate("setSingleDate", sDate);
        }
    },

    getDate: function () {
        // return this.dates;
        return this.mycal.vcDate("getDate");
    },
    getDateRange: function () {
        // return this.dates;
        return this.mycal.vcDate("getDateRange");
    },


    _create: function () {
        var me = this;
        me.mycal = $("<div>");
        this.element.vcOptionBox({langID: me.options.langID,
            caption: me._getResources().defaultCaption,
            items: [
                {button: me._getResources().date, content: me.mycal,
                    clickable:false,
                    funct: function () {

                        me.mycal.vcDate({
                            langID: me.options.langID, mode: me.options.mode, align: me.options.align, interval: me.options.interval,
                            defaultDate: me.options.defaultDate, defaultRange: me.options.defaultRange, callback: me.options.callback
                        });
                    }
                }
            ]
        });
        return this;
    }
    , destroy: function () {
        this.mycal.vcDate("destroy");
        this.element.removeClass("vc-option-box").html("");
        this.options.callback = null;
        $(this).off(this.eventNamespace);
        // remove jQuery data cache
        this.element.removeData(this.eventNamespace).remove(this.eventNamespace);
        this._super();
    }
   

});


$.widget("bluaul.vcFullDateBox",
{
    /// <summary>

    /// Author: AFU<br />
    /// Date: 3.12.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.11.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    self: null,

   
    dates: { from: null, to: null },
    resources: window.__OptionBoxResources,

    _getResources: function () { return this.resources[this.options.langID - 2]; },

    options: {
        langID: 2, align: "center", interval: 1,callback: null
    },

    callback: function () {
        if ($.isFunction(this.options.callback)) {
            this.options.callback();
        }
    },
    getDate: function () {
        // return this.dates;
       return this.element.find("#cal" + this.element.vcOptionBox("getIndex")).vcDate("getDate");
        },


    setSingleDate: function (sDate) {
        this.element.find("#cal" + this.element.vcOptionBox("getIndex")).vcDate("setSingleDate", sDate);
    },


    _setOption: function (key, value) {
        if (key === "value") {
            value = this._constrain(value);
        }
        this._super(key, value);
    },

    refresh: function () {
        var currentIndex = this.element.vcOptionBox("getIndex");
        this.dates = this.element.find("#cal" + currentIndex).vcDate("getDate");
        this.element.vcOptionBox("destroy");
        this._create();
        this.element.vcOptionBox("selectItem", currentIndex);
    },
    getIndex: function () {
        return this.index;
    },

    _destroy: function () {
        this.element.vcOptionBox("destroy");
        this.element.html("");
    },
  
    _create: function () {
        var me = this;

        this.element.vcOptionBox({
            caption: this._getResources().defaultCaption, langID: me.options.langID, items: [
                {
                    button: this._getResources().date, clickable: true, content: $("<div>").attr("id", "cal0").addClass("date-box"),
                    funct: function () {
                        me.element.find("#cal0").vcDate({
                            langID: me.options.langID,
                            mode: "Single", align: me.options.align, interval: me.options.interval, defaultDate: me.dates.from,
                            callback: function () { me.callback();}
                        });
                      //  me._updateDates(0);
                    }
                },
                {
                    button: this._getResources().interval, clickable: true, content: $("<div>").attr("id", "cal1").addClass("date-box"),
                    funct: function () {
                        me.element.find("#cal1").vcDate({
                            langID: me.options.langID,
                            mode: "Range", align: me.options.align, interval: 1,
                            callback: function () { 
                                me.callback();
                             
                            }
                        });
                       // me._updateDates(1);
                    }
                }
            ]
        });
        return this;
    }
    , destroy: function () {
        this.options.callback = null;
        this._super();
    }
});